import {BBModel} from '../bb_model';
import {context} from '../constants/context';
import {halClient} from '../hal';

const service = {
    getServicesByCategory(categoryId, services) {
        return Promise.resolve(services.filter(service => service.category_id === categoryId));
    },

    query(company) {
        return new Promise((resolve, reject) => {
            if (!company.$has('services')) {
                reject('No services found');
            } else {
                company
                    .$get('services')
                    .then((resource) => {
                        return resource
                            .$get('services')
                            .then((items) => {
                                const services = [];

                                for (const i of Array.from(items)) {
                                    services.push(new BBModel.Service(i));
                                }

                                resolve(services);
                            })
                            .catch((error) => {
                                reject(error);
                            });
                    })
                    .catch((error) => {
                        reject(error);
                    });
            }

        });
    },

    async queryByParams(params={}) {
        const companyId = params.company.id;

        let queryParams = '';
        if (params.categoryId) {
            queryParams += `&category_id=${params.categoryId}`;
        }

        if (params.page) {
            queryParams += `&page=${params.page}`;
        }

        if (params.per_page) {
            queryParams += `&per_page=${params.per_page}`;
        }

        if (params.processType === 'bbQueuingTablet') {
            queryParams += '&queuing_disabled=false';
        }

        const url = `${context.apiUrl}/api/${context.apiVersion}/${companyId}/services/?exclude_links[]=child_services&availability[]=0${queryParams}`;
        return await halClient.$get(url, {no_cache: params.no_cache});
    },

    async queryById(companyId, serviceId) {
        const url = `${context.apiUrl}/api/${context.apiVersion}/${companyId}/services/${serviceId}`;
        return new BBModel.Service(await halClient.$get(url));
    },

    async queryByReference(companyId, reference) {
        try {
            const url = `${context.apiUrl}/api/${context.apiVersion}/${companyId}/services/find_by_ref/${reference}`;
            return new BBModel.Service(await halClient.$get(url));
        } catch (ignored) {
            return Promise.reject('Invalid service reference: ' + reference);
        }
    }
};

export {
    service
};
